import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';
import { gitlabSlug, sonarProjectKey } from './signals';

// PT-52 - the two missing Execution Plan section 5.1 capabilities as entity cards.
// Each `filter` keeps the card off entities the signal cannot be resolved for, so a
// Group, a User or the static control-plane Component shows nothing rather than an
// empty card.
//
// PT-54 - the filters resolve rather than look up an annotation: role 19 stamps both
// annotations at ONBOARD time, so every project onboarded before PT-52 carries
// neither and would show no card at all. Both values are derivable from what the
// GitLab discovery provider already records (see signals.ts), so an already-onboarded
// component gets both cards with no commit to its repository.

const pipelineStatusCard = EntityCardBlueprint.make({
  name: 'gitlab-pipeline-status',
  params: {
    filter: (entity: Entity) => !!gitlabSlug(entity),
    loader: async () => {
      const { PipelineStatusCard } = await import('./Cards');
      return <PipelineStatusCard />;
    },
  },
});

const qualityGateCard = EntityCardBlueprint.make({
  name: 'sonarqube-quality-gate',
  params: {
    filter: (entity: Entity) => !!sonarProjectKey(entity),
    loader: async () => {
      const { QualityGateCard } = await import('./Cards');
      return <QualityGateCard />;
    },
  },
});

export const deliverySignalsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [pipelineStatusCard, qualityGateCard],
});
